import { useSelector } from "react-redux";
import { ApplicationState } from "@ppb/tbd-store";

const SUPER_SUB_VARIANT = "exp-market-super-sub-icon";

/**
 * Whether the super-sub icon experiment is active.
 *
 * Prismic requires unique experiment names, so each brand has its own (SBG's `exp-market-super-sub-icon`,
 * Betfair's `bf-exp-market-super-sub-icon`) while sharing the same variant. Only the variant is checked,
 * whatever the experiment is called.
 *
 * The package cannot read the host's experiment state, so the host answers this and passes it down, the
 * same way it supplies `isDesktopLayout`. The legacy component read it through `mapStateToProps`; this is
 * that read as a hook, for the adapter.
 *
 * The active variant is named after the experiment rather than something like "on".
 */
export function useSuperSubExperiment(): boolean {
  return useSelector((state: ApplicationState) =>
    Object.values(state.entities.experiments ?? {}).some((experiment) => experiment?.variant === SUPER_SUB_VARIANT),
  );
}
